import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var MultipleChoiceFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.755 1.565c-.79-.79-2.121-.79-2.91 0L28.976 13.526 24.5 9.048c-.79-.79-2.121-.79-2.91 0-.79.79-.79 2.121 0 2.91l5.886 5.887c.79.79 2.121.79 2.91 0l13.37-13.37c.79-.789.79-2.12 0-2.91Zm-13.47 41.319 5.28-5.28 5.28 5.28c.789.79 2.12.79 2.91 0s.79-2.121 0-2.911l-5.28-5.28 5.28-5.278c.79-.79.79-2.122 0-2.911-.79-.79-2.121-.79-2.91 0l-5.28 5.279-5.28-5.28c-.789-.789-2.12-.789-2.91 0-.79.79-.79 2.122 0 2.912l5.28 5.279-5.28 5.279c-.79.79-.79 2.121 0 2.91.79.79 2.121.79 2.91 0Zm-26.435 0 5.28-5.28 5.279 5.28c.79.79 2.121.79 2.91 0 .79-.79.79-2.121 0-2.911l-5.278-5.28 5.279-5.278c.79-.79.79-2.122 0-2.911-.79-.79-2.121-.79-2.911 0l-5.28 5.279-5.279-5.28c-.79-.789-2.12-.789-2.91 0-.79.79-.79 2.122 0 2.912l5.279 5.279-5.28 5.279c-.789.79-.789 2.121 0 2.91.79.79 2.122.79 2.911 0Zm13.47-25.039c.79-.79.79-2.12 0-2.91l-5.18-5.18 5.28-5.28c.79-.789.79-2.12 0-2.91s-2.122-.79-2.911 0l-5.28 5.28-5.279-5.28c-.79-.79-2.121-.79-2.91 0A2.119 2.119 0 0 0 .435 2.96C.415 3.404.53 3.966.94 4.376l5.279 5.28-5.28 5.278c-.789.79-.789 2.122 0 2.911.79.79 2.122.79 2.911 0l5.28-5.279 5.279 5.28c.79.789 2.121.789 2.91 0Z"
  }));
});
MultipleChoiceFill.displayName = 'MultipleChoiceFill';
MultipleChoiceFill.defaultProps = {
  'aria-label': 'MultipleChoiceFill'
};
export default MultipleChoiceFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/MultipleChoiceFill.js
// module id = 3851
// module chunks = 11